import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import countriesService from './countriesService'


const initialState = {
    countries: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}

export const countriesSlice = createSlice({
    name: 'countries',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCountries.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getCountries.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.countries = action.payload
                state.isError = false
            })
            .addCase(getCountries.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })
    }
})

export const getCountries = createAsyncThunk('countries/getCountries', async (_, thunkAPI) => {
    try {
        return await countriesService.getCountries()
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const { reset } = countriesSlice.actions
export default countriesSlice.reducer
